import { memo, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { MoreHoriz as IconMoreHoriz } from "@mui/icons-material";

export default memo(function MenuMore({ options = [], onSelect, title }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton variant="outlined" onClick={handleClick} title={title} size="large">
        <IconMoreHoriz />
      </IconButton>
      <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
        {options.map((option, i) => (
          <MenuItem key={i} onClick={onSelect} value={i}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
});
